import axios from "axios";
import {
  GET_ORDER_REQUEST,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAIL,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAIL,
  APPROVE_ORDER_REQUEST,
  APPROVE_ORDER_SUCCESS,
  APPROVE_ORDER_FAIL,
  MARK_PICKED_ORDER_REQUEST,
  MARK_PICKED_ORDER_SUCCESS,
  MARK_PICKED_ORDER_FAIL,
  ORDER_CANCEL_REQUEST,
  ORDER_CANCEL_SUCCESS,
  ORDER_CANCEL_FAIL,
  GET_ORDER_DELIVERED_REQUEST,
  GET_ORDER_DELIVERED_SUCCESS,
  GET_ORDER_DELIVERED_FAIL,
  SAVE_PICKUP_INFO,
  SAVE_PICKUP_INFO_ERROR,
  SAVE_DROPOFF_INFO,
  SAVE_DROPOFF_INFO_ERROR,
  SAVE_COURIER_INFO,
  SAVE_COURIER_INFO_ERROR,
  SAVE_PAYMENT_INFO,
  SAVE_PAYMENT_INFO_ERROR,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAIL,
  MARK_DELIVERED_ORDER_REQUEST,
  MARK_DELIVERED_ORDER_SUCCESS,
  MARK_DELIVERED_ORDER_FAIL,
  GET_ORDER_ADMIN_REQUEST,
  GET_ORDER_ADMIN_SUCCESS,
  GET_ORDER_ADMIN_FAIL,
  SAVE_LHW_ERROR,
  SAVE_LENGTH,
  SAVE_HEIGTH,
  SAVE_WIDTH,
  GET_LAT_LONG,
  GET_LAT_LONG_ERROR,
  GET_DIRECTION,
  GET_DIRECTION_ERROR,
  GET_DIRECTION_REQUEST,
} from "../types/orderTypes";

export const getOrder = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ORDER_REQUEST });

    const config = {
      headers: {
        "x-auth-token": getState().userLogin.userInfo.jwt,
      },
    };

    const { data } = await axios.get(
      "https://uora.herokuapp.com/api/orders/",
      config
    );

    dispatch({ type: GET_ORDER_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: GET_ORDER_FAIL, payload: err.message });
  }
};

export const getOrderAdmin = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ORDER_ADMIN_REQUEST });

    const { data } = await axios.get(
      "https://uora.herokuapp.com/api/orders/allOrders"
    );

    dispatch({ type: GET_ORDER_ADMIN_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: GET_ORDER_ADMIN_FAIL, payload: err.message });
  }
};

export const getOrderById = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ORDER_BY_ID_REQUEST });

    const config = {
      headers: {
        "x-auth-token": getState().userLogin.userInfo.jwt,
      },
    };

    const { data } = await axios.get(
      `https://uora.herokuapp.com/api/orders/${id}`,
      config
    );

    dispatch({ type: GET_ORDER_BY_ID_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: GET_ORDER_BY_ID_FAIL, payload: err.message });
  }
};

export const getOrderByIdAdmin = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_ORDER_BY_ID_REQUEST });

    const { data } = await axios.get(
      `https://uora.herokuapp.com/api/orders/order_by_id/${id}`
    );

    dispatch({ type: GET_ORDER_BY_ID_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: GET_ORDER_BY_ID_FAIL, payload: err.message });
  }
};

export const approveOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: APPROVE_ORDER_REQUEST });

    const approveForm = { status: "accepted" };
    const { data } = await axios.put(
      `https://uora.herokuapp.com/api/orders/${id}`,
      approveForm
    );

    dispatch({ type: APPROVE_ORDER_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: APPROVE_ORDER_FAIL, payload: err.message });
  }
};

export const markPickedOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: MARK_PICKED_ORDER_REQUEST });

    const markForm = { status: "picked" };
    const { data } = await axios.put(
      `https://uora.herokuapp.com/api/orders/${id}`,
      markForm
    );

    dispatch({ type: MARK_PICKED_ORDER_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: MARK_PICKED_ORDER_FAIL, payload: err.message });
  }
};

export const cancelOrder = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_CANCEL_REQUEST });

    const { data } = await axios.put(
      `https://uora.herokuapp.com/api/orders/cancelled/${id}`
    );

    dispatch({ type: ORDER_CANCEL_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: ORDER_CANCEL_FAIL, payload: err.message });
  }
};

export const markDeliveredOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: MARK_DELIVERED_ORDER_REQUEST });

    const deliverForm = { status: "delivered" };
    const { data } = await axios.put(
      `https://uora.herokuapp.com/api/orders/${id}`,
      deliverForm
    );

    dispatch({ type: MARK_DELIVERED_ORDER_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: MARK_DELIVERED_ORDER_FAIL, payload: err.message });
  }
};

export const getDeliveredOrder = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ORDER_DELIVERED_REQUEST });

    // const config = {
    //   headers: {
    //     "x-auth-token": getState().userLogin.userInfo.jwt,
    //   },
    // };

    const { data } = await axios.get(
      `https://uora.herokuapp.com/api/orders/delivered`
    );

    dispatch({ type: GET_ORDER_DELIVERED_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: GET_ORDER_DELIVERED_FAIL, payload: err.message });
  }
};

export const savePickupLocation = (data) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_PICKUP_INFO, payload: data });
  } catch (err) {
    dispatch({ type: SAVE_PICKUP_INFO_ERROR, payload: err.message });
  }
};

export const saveDropoffLocation = (data) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_DROPOFF_INFO, payload: data });
  } catch (err) {
    dispatch({ type: SAVE_DROPOFF_INFO_ERROR, payload: err.message });
  }
};

export const saveLength = (length, history) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_LENGTH, payload: length });

    history.push("/courier-info");
  } catch (err) {
    dispatch({ type: SAVE_LHW_ERROR, payload: err.message });
  }
};
export const saveHeigth = (heigth, history) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_HEIGTH, payload: heigth });
    history.push("/courier-info");
  } catch (err) {
    dispatch({ type: SAVE_LHW_ERROR, payload: err.message });
  }
};
export const saveWidth = (width, history) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_WIDTH, payload: width });

    history.push("/courier-info");
  } catch (err) {
    dispatch({ type: SAVE_LHW_ERROR, payload: err.message });
  }
};

export const saveCourierInfoLocation = (data) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_COURIER_INFO, payload: data });
  } catch (err) {
    dispatch({ type: SAVE_COURIER_INFO_ERROR, payload: err.message });
  }
};

export const savePaymentInfo = (data) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_PAYMENT_INFO, payload: data });
  } catch (err) {
    dispatch({ type: SAVE_PAYMENT_INFO_ERROR, payload: err.message });
  }
};

export const placeOrder = (
  courierInfo,
  pickup,
  dropoff,
  payment,
  payment_amount,
  typeOfOrder,
  history
) => async (dispatch, getState) => {
  try {
    dispatch({ type: PLACE_ORDER_REQUEST });

    const config = {
      headers: {
        "x-auth-token": getState().userLogin.userInfo.jwt,
      },
    };

    const { data } = await axios.post(
      `https://uora.herokuapp.com/api/orders/`,
      { courierInfo, pickup, dropoff, payment, payment_amount, typeOfOrder },
      config
    );

    dispatch({ type: PLACE_ORDER_SUCCESS, payload: data });
    history.push("/");
  } catch (err) {
    dispatch({ type: PLACE_ORDER_FAIL, payload: err.message });
  }
};

export const getLatLng = (address) => async (dispatch) => {
  try {
    const { data } = await axios.post(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyBs18XKLLip0CBo__x3a33ADc5N1VA1mfE`
    );

    dispatch({ type: GET_LAT_LONG, payload: data });
  } catch (err) {
    dispatch({ type: GET_LAT_LONG_ERROR, payload: err.message });
  }
};

export const getDirection = (from, to) => async (dispatch) => {
  try {
    dispatch({ type: GET_DIRECTION_REQUEST });

    const { data } = await axios.post(
      `https://maps.googleapis.com/maps/api/directions/json?origin=${from}&destination=${to}&key=AIzaSyBs18XKLLip0CBo__x3a33ADc5N1VA1mfE`
    );
    dispatch({ type: GET_DIRECTION, payload: data });
  } catch (err) {
    dispatch({ type: GET_DIRECTION_ERROR, payload: err.message });
  }
};
